import { createRoot } from "react-dom/client";
import "regenerator-runtime/runtime";
import "regenerator-runtime/runtime";

import { IntlProvider } from "@mnemonic/intl";
import { CardHttpError, PageGenericError, RemoveSplash } from "@mnemonic/mui";

import Application from "./Application";
import PromiseBootstrap from "./Bootstrap";
import HttpError from "./Bootstrap/Errors/HttpError";

document.addEventListener("DOMContentLoaded", () => {
  const onException = (ex: Error) => {
    console.error(ex);
    const root = createRoot(document.getElementById("root"));
    root.render(
      <>
        <IntlProvider locale="en-US">
          <RemoveSplash />
          {HttpError.isHttpError(ex) && <CardHttpError error={ex} request={ex.request} response={ex.response} />}
          {!HttpError.isHttpError(ex) && <PageGenericError title="Unrecoverable error" error={ex} />}
        </IntlProvider>
      </>,
    );
  };

  // eslint-disable-next-line new-cap
  PromiseBootstrap().then((values) => {
    try {
      const { session, intl } = values;

      const root = createRoot(document.getElementById("root"));

      root.render(<Application {...{ session, intl }} />);
    } catch (ex) {
      onException(ex);
    }
  }, onException);
});
